import Swiper from 'swiper';

// CONSTANTS are all caps.
const NS = 'CtaButtonCarousel';
const CLS = 'ctaButtonCarousel';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class CtaButtonCarousel {

	constructor($el) {
		// $el is the blk node return by the loadCtaButtonCarousel function
		this.$el = $el;
		this.$queryBlock = $($el);
		this.options = {
			css: {
				color: this.$queryBlock.data('text-color') || 'black',
				borderColor: this.$queryBlock.data('btn-bg-color') || 'black',
				background: 'transparent',
			},
			cssActive: {
				color: this.$queryBlock.data('selected-text-color') || 'white',
				borderColor: this.$queryBlock.data('btn-bg-color') || 'black',
				background: this.$queryBlock.data('btn-bg-color') || 'black',
			},
		};
	}

	init() {
		this.setCtaButtonCarousel();
	}

	setCtaButtonCarousel() {
		this.updateStyle();
		this.registerEvents();
		this.setFirstLoad();
	}
	setFirstLoad() {
		this.swiper = new Swiper(this.$queryBlock.find('.ctaButtonCarousel_buttons')[0], {
			slidesPerView: 'auto',
			freeMode: true,
			direction: 'horizontal',
			mousewheel: true,
		});

		this.handleTabActive(0);
		this.$queryBlock.addClass('is-initialized');
	}

	registerEvents() {
		this.$queryBlock.on('click', '.ctaButtonCarousel_button', ({ target }) => {
			const index = $(target).index();
			this.handleTabActive(index);
		});

		this.$queryBlock.find('.ctaButtonCarousel_button').mouseenter(({ target }) => {
			!$(target).hasClass('active') && $(target).css(this.options.cssActive);
		});

		this.$queryBlock.find('.ctaButtonCarousel_button').mouseout(({ target }) => {
			!$(target).hasClass('active') && $(target).css(this.options.css);
		});
	}

	updateStyle() {
		this.$queryBlock.find('.ctaButtonCarousel_button').css(this.options.css);
	}

	handleTabActive(index) {
		const $buttons = this.$queryBlock.find('.ctaButtonCarousel_button');
		const $contents = this.$queryBlock.find('.ctaButtonCarousel_content');
		const $links = this.$queryBlock.find('.ctaButtonCarousel_link');

		$buttons.css(this.options.css);
		$buttons.removeClass('active');
		$contents.removeClass('active');
		$links.removeClass('active');

		$buttons.eq(index).addClass('active');
		$contents.eq(index).addClass('active');
		$buttons.eq(index).css(this.options.cssActive);
		$links.eq(index).addClass('active');

		this.swiper.update();
	}

	//Add more functions like on above here

}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/src/views/blocks/ctaButtonCarousel/js/ctaButtonCarousel.js